import React, { useEffect, useState } from 'react'
import { DocumentData } from 'firebase/firestore'
import Card from '@components/Cards/Card'
import { LocalStorageItem, RowTypes, SessionStorageItem } from '../../constants'
import './MyList.scss'
import SpatialNavigation from '@utils/spatial-navigation.js'
import EmptyListContainer from '@components/EmptyListContainer/EmptyListContainer'
import Skeleton from '@pages/Skeleton/Skeleton'
import { addLastFocusedItemToSS, disableMoveDown, getActiveProfile } from '@utils/helpers'
import Text from '@components/Text/Text'
import { TextTag } from '@enums/textTag'
import { VelvetSDK } from 'sdk'
import { CardsNumber } from '@enums/cards.enum'

interface MyListProps {
  showMenu: (status: boolean) => void
}

const MyList = ({ showMenu }: MyListProps) => {
  const userObject = JSON.parse((localStorage.getItem(LocalStorageItem.USER_DATA) as string) ?? null)
  const userId = userObject?.userID
  const [myListCards, setMyListCards] = useState<DocumentData[]>()
  const [isLoading, setIsLoading] = useState(true)
  const SN = SpatialNavigation
  const V = VelvetSDK.Vocabulary.vocabulary
  const lastFocusedCard = JSON.parse(sessionStorage.getItem(SessionStorageItem.LAST_FOCUSED_ITEM_MY_LIST) as string)
  const findLastFocusedCard = myListCards?.find((card) => card.id === lastFocusedCard)
  const activeProfile = getActiveProfile()

  useEffect(() => {
    showMenu(true)
  }, [showMenu])

  useEffect(() => {
    if (userId) {
      setIsLoading(true)
      activeProfile?.identifier &&
        VelvetSDK.Storage.Favorites.service
          .getItems(userId, activeProfile?.identifier)
          .then((res) => {
            setMyListCards(res)
            setIsLoading(false)
          })
          .catch((error: Error) => {
            console.log('Error getting items from My List:', error)
            setIsLoading(false)
          })
    }
  }, [userId, activeProfile?.identifier])

  useEffect(() => {
    if (myListCards) {
      lastFocusedCard && findLastFocusedCard ? SN.focus(`#${lastFocusedCard}`) : SN.focus('my-list')
    }
  }, [myListCards, SN, lastFocusedCard, findLastFocusedCard])

  return (
    <div className="my-list">
      {isLoading ? (
        <Skeleton />
      ) : (
        <>
          <Text tag={TextTag.P} className="my-list-title">
            {V.menuItemMyList}
          </Text>
          {myListCards && myListCards.length > 0 ? (
            <div className="card-wrapper">
              {myListCards.map((element: DocumentData, index: number) => {
                return (
                  <Card
                    key={index}
                    item={element}
                    rowType={RowTypes.MYLIST}
                    index={index}
                    isFocusable={true}
                    lastFocusedCard={() => addLastFocusedItemToSS(element.id, RowTypes.MYLIST)}
                    disableMoveDown={disableMoveDown(index, myListCards, CardsNumber.MY_LIST)}
                  />
                )
              })}
            </div>
          ) : (
            <EmptyListContainer
              firstSubtitle={V.myListPageEmptyTitle}
              secondSubtitle={V.myListPageEmptyDescription}
              buttonTitle={V.myListPageEmptyButtonText}
            />
          )}
        </>
      )}
    </div>
  )
}

export default MyList
